import { useSubmitBankAccountConnectionErrorMutation } from '@twisto/api-graphql'
import { TextButton } from '@twisto/components/atoms/button'
import {
  Headline,
  HeadlineIcon,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twisto/components/atoms/headline'
import { BigBankDeclineIcon } from '@twisto/icons'

import { useFlow } from '../../flow/flow.context'

import * as styles from './bank-account-connection-error-step.styles'

export const BankAccountConnectionErrorStep = () => {
  const { sessionId, flow } = useFlow<'BankAccountConnectionErrorStep'>()

  const [submitBankAccountConnectionError] =
    useSubmitBankAccountConnectionErrorMutation()

  const currentStep = flow.currentStep

  const handleSubmit = () => {
    submitBankAccountConnectionError({
      variables: {
        auth: {
          sessionId,
        },
      },
    })
  }

  return (
    <div css={styles.root}>
      <Headline css={styles.headline}>
        <HeadlineIcon>
          <BigBankDeclineIcon color="error" height="100%" width="100%" />
        </HeadlineIcon>
        <HeadlineTitle>{currentStep.heading}</HeadlineTitle>
        <HeadlineSubtitle>{currentStep.text}</HeadlineSubtitle>
      </Headline>
      <TextButton fullWidth onClick={handleSubmit}>
        {currentStep.buttonText}
      </TextButton>
    </div>
  )
}
